"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Permission = exports.RoleName = void 0;
var RoleName;
(function (RoleName) {
    RoleName["GLOBAL_ADMIN"] = "global administrator";
    RoleName["ORG_ADMIN"] = "organization administrator";
    RoleName["TICKET_AGENT"] = "ticket agent";
    RoleName["TICKET_MANAGER"] = "ticket manager";
})(RoleName || (exports.RoleName = RoleName = {}));
var Permission;
(function (Permission) {
    Permission["CATEGORIES"] = "categories";
    Permission["COMMUNICATIONS"] = "communications";
    Permission["DEPOSITS"] = "deposits";
    Permission["DEPOSITS_MERCHANTS"] = "deposits.merchant";
    Permission["DEPOSITS_PLATFORM"] = "deposits.platform";
    Permission["EVENTS"] = "events";
    Permission["FINANCIALS"] = "financial";
    Permission["FORMS"] = "forms";
    Permission["ORGANIZATIONS"] = "organizations";
    Permission["PEOPLE"] = "people";
    Permission["PRODUCTS"] = "products";
    Permission["TEAMS"] = "teams";
    Permission["TICKETS"] = "tickets";
    Permission["TICKET_TIERS"] = "ticket_tiers";
    Permission["TICKET_REFUNDS"] = "ticket_refunds";
    Permission["TICKETING"] = "ticketing";
    Permission["TRANSACTIONS"] = "transactions";
    Permission["USERS"] = "users";
})(Permission || (exports.Permission = Permission = {}));
